import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OpenLayer {
    isOpen: boolean;
    src: string;
}

const initialState: OpenLayer = {
    isOpen: false,
    src: ''
}

export const layerSlice = createSlice({
    name: "layer",
    initialState: initialState,
    reducers: {
        open: (state, action: PayloadAction<string>) => {
            state.isOpen = true;
            state.src = action.payload;
        },
        close: state => {
            state.isOpen = false;
        }
    }
});

export const { open, close } = layerSlice.actions;

export default layerSlice.reducer;